import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  { path: 'analytics', lazy: async () => ({ Component: (await import('./AnalyticsPage')).AnalyticsPage }) },
];
